import { apiSlice } from './apiSlice';
import { SHIFTREQUESTAGENCY_URL } from '../constants';

export const shiftRequestAgencyApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new shift request
    createShiftRequestAgency: builder.mutation({
      query: (shiftRequestAgencyData) => ({
        url: `${SHIFTREQUESTAGENCY_URL}`,
        method: 'POST',
        body: shiftRequestAgencyData,
      }),
    }),

    getShiftRequestsAgencyByShiftId: builder.query({
      query: (shiftId) => `${SHIFTREQUESTAGENCY_URL}/shift-requests-agency/${shiftId}`,
}),



    // Get all shift requests
    getShiftRequestsAgency: builder.query({
      query: () => ({
        url: `${SHIFTREQUESTAGENCY_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Add this inside endpoints: (builder) => ({ ... })
getShiftRequestsAgencyByAgencyId: builder.query({
  query: (agencyId) => ({
    url: `${SHIFTREQUESTAGENCY_URL}/agency/${agencyId}`,
  }),
  keepUnusedDataFor: 5,
}),

updateShiftRequestAgencyStatus: builder.mutation({
  query: ({ shiftRequestId, lineStatus }) => ({
    url: `${SHIFTREQUESTAGENCY_URL}/linestatus/${shiftRequestId}`,
    method: 'PATCH',
    body: { lineStatus },
  }),
}),





    // Get a single shift by ID
    getShiftRequestAgencyById: builder.query({
      query: (shiftRequestId) => ({
        url: `${SHIFTREQUESTAGENCY_URL}/${shiftRequestId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Update a shift
    updateShiftRequestAgency: builder.mutation({
  query: (data) => ({
        url: `${SHIFTREQUESTAGENCY_URL}/${data.shiftRequestId}`,
        method: 'PUT',
        body: data,
  }),
}),



    // Delete a shift (logical or physical based on your controller logic)
    deleteShiftRequestAgency: builder.mutation({
      query: (requestId) => ({
        url: `${SHIFTREQUESTAGENCY_URL}/${requestId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreateShiftRequestAgencyMutation,
  useGetShiftRequestsAgencyQuery,
  useGetShiftRequestAgencyByIdQuery,
  useGetShiftRequestsAgencyByAgencyIdQuery,
  useUpdateShiftRequestAgencyMutation,
  useDeleteShiftRequestAgencyMutation,
  useGetShiftRequestsAgencyByShiftIdQuery,
  useUpdateShiftRequestAgencyStatusMutation,
} = shiftRequestAgencyApiSlice;
